export type DefaultProcedureItem = {
  code: string
  name: string
  price?: number
  priceMidlevel?: number
}

export const DEFAULT_PROCEDURES: DefaultProcedureItem[] = [
  { code: '99214', name: 'moderate complexity office visit OS', price: 270, priceMidlevel: 230 },
  { code: '99215', name: 'high complexity office visit OS', price: 375, priceMidlevel: 320 },
  {
    code: '99395',
    name: 'well person preventative visit, OS age 18 - 39',
    price: 225,
    priceMidlevel: 190,
  },
  {
    code: '99396',
    name: 'well person preventative visit, age 40 - 65 OS',
    price: 275,
    priceMidlevel: 235,
  },
  { code: '99211', name: 'Minimal established-patient service', price: 50, priceMidlevel: 45 },
  {
    code: '99212',
    name: 'Established patient, straightforward MDM or 10-19 min',
    price: 120,
    priceMidlevel: 100,
  },
  {
    code: '99213',
    name: 'low-moderate complexity office visit OS',
    price: 190,
    priceMidlevel: 160,
  },
  {
    code: '99397',
    name: 'well person preventative visit, age 65 and over OS',
    price: 300,
    priceMidlevel: 255,
  },
  { code: 'G0402', name: 'Welcome to Medicare / IPPE', price: 350, priceMidlevel: 300 },
  { code: 'G0438', name: 'Initial Annual Wellness Visit', price: 350, priceMidlevel: 300 },
  {
    code: 'G0439',
    name: 'Medicare well person preventative visit',
    price: 275,
    priceMidlevel: 235,
  },
  { code: 'G0181', name: 'home health oversight' },
  { code: 'Q0091', name: 'pap smear' },
  { code: '96372', name: 'injection, procedure only OS' },
  { code: '90471', name: 'vaccine injection, procedure only OS' },
  {
    code: '99202',
    name: 'New patient, straightforward MDM or 15-29 min',
    price: 150,
    priceMidlevel: 130,
  },
  {
    code: '99203',
    name: 'new patient, low-moderate complexity office visit OS',
    price: 225,
    priceMidlevel: 190,
  },
  {
    code: '99204',
    name: 'new patient, moderate complexity office visitOS',
    price: 340,
    priceMidlevel: 290,
  },
  {
    code: '99205',
    name: 'new patient, high complexity office visit OS',
    price: 430,
    priceMidlevel: 365,
  },
  { code: '93000', name: 'routine electrocardiogram (ECG) OS', price: 50 },
  {
    code: '99385',
    name: 'Preventive exam, new patient (18–39 yrs) OS',
    price: 275,
    priceMidlevel: 235,
  },
  {
    code: '99386',
    name: 'Preventive exam, new patient (40–64 yrs)OS',
    price: 325,
    priceMidlevel: 275,
  },
  { code: '99387', name: 'Preventive visit, new patient, age 65+', price: 350, priceMidlevel: 300 },
  { code: 'G0442', name: 'Annual alcohol screening', price: 150 },
  { code: 'G0443', name: 'alcohol counseling (4x a year)', price: 100 },
  { code: 'G0444', name: 'Annual depression screening OS', price: 150 },
  { code: '36415', name: 'Venipuncture (blood draw)', price: 50 },
  { code: '83036', name: 'Hemoglobin A1c (HbA1c) test OS', price: 50 },
  { code: '87804', name: 'Rapid flu test OS', price: 50 },
  { code: '81001', name: 'Urinalysis, automated w/ microscopy OS', price: 50 },
  { code: '99424', name: 'Principal Care Management (PCM), physician time', price: 250 },
  { code: '99425', name: 'PCM, additional physician time', price: 150 },
  { code: '99426', name: 'PCM, clinical staff time (20 min)', price: 100 },
  { code: '99490', name: 'Chronic Care Management (CCM), 20 min OS', price: 200 },
  { code: '99439', name: 'CCM, additional 20 min OS', price: 150 },
  {
    code: 'G2211',
    name: 'office and outpatient evaluation and management services OS',
    price: 35,
    priceMidlevel: 30,
  },
  { code: '99406', name: 'Smoking counseling OS', price: 100 },
  { code: 'G0102', name: 'prostate exam for CA screening', price: 100 },
  {
    code: 'G0101',
    name: 'cervical or vaginal cancer screening, including a pelvic and clinical breast examination',
    price: 150,
  },
  { code: '69210', name: 'cerumen removal by physician with curette OS', price: 50 },
  { code: 'G0447', name: 'obesity counseling', price: 100 },
  {
    code: '99401',
    name: 'Preventive medicine counseling and/or risk factor reduction intervention(s) provided to an individual for 15 minutes',
    price: 100,
  },
  {
    code: '99408',
    name: 'alcohol and/or substance abuse structured screening and brief intervention services lasting between 15 and 30 minutes',
    price: 100,
  },
  {
    code: '17000',
    name: 'Destruction of premalignant lesion (e.g., actinic keratosis) using procedures like cryotherapy; first lesion only. OS',
    price: 150,
  },
  {
    code: '81002',
    name: 'Urinalysis, non-automated, without microscopy; commonly used for basic screening (e.g., dipstick tests). OS',
    price: 100,
  },
  {
    code: '96116',
    name: 'Neurobehavioral status exam by a clinician, including assessment of thinking, memory, and reasoning OS',
    price: 150,
  },
  {
    code: '99457',
    name: 'Remote physiologic monitoring (RPM) treatment management services; 20+ minutes of clinical staff/physician time in a month, requiring interactive communication with the patient. OS',
    price: 150,
  },
  {
    code: '99454',
    name: 'Remote monitoring device supply and data transmission; covers the setup, supply, and daily data transmission of RPM devices (e.g., blood pressure cuffs, glucose monitors).OS',
    price: 150,
  },
  { code: '78267', name: 'Urea breath test; acquisition of breath sample OS', price: 100 },
  {
    code: '17003',
    name: 'Destruction of each additional premalignant lesion (2–14 lesions), used in conjunction with 17000.',
    price: 100,
  },
  {
    code: '17004',
    name: 'Destruction of 15 or more premalignant lesions in a single treatment session, reported as a standalone code. OS',
    price: 100,
  },
  { code: 'J2405', name: 'Injection, ondansetron hydrochloride, per 1 mg OS', price: 50 },
  {
    code: '96127',
    name: 'Brief emotional/behavioral assessment with scoring and documentation, using a standardized instrument OS',
    price: 50,
  },
  {
    code: '93923',
    name: 'non-invasive physiologic study of upper or lower extremity arteries, multiple levels or with provocative functional maneuvers, complete bilateral study OS',
    price: 100,
  },
  {
    code: '94618',
    name: 'Pulmonary stress testing (e.g., 6-minute walk test), including measurement of heart rate, oximetry, and oxygen titration, when performed. OS',
    price: 100,
  },
  {
    code: '94619',
    name: 'Pulmonary stress testing specifically measurement of oxygen uptake during exercise for assessing oxygen consumption and cardiorespiratory statusOS',
    price: 100,
  },
  {
    code: '94010',
    name: 'Spirometry, including graphic record, total and timed vital capacity, expiratory flow rate measurement(s), with or without maximal voluntary ventilation. OS',
    price: 100,
  },
  {
    code: 'G2064',
    name: 'comprehensive care management services for a single high-risk disease, specifically Principal Care Management (PCM)',
    price: 100,
  },
  {
    code: 'G2065',
    name: 'Principal Care Management (PCM) services provided by clinical staff under the direction of a physician or other qualified health care professional. It requires at least 30 minutes of clinical time',
    price: 100,
  },
  {
    code: '99000',
    name: "Handling and/or conveyance of specimen for transfer from the physician's office to a laboratory.",
    price: 50,
  },
  {
    code: '96160',
    name: 'Patient‑focused health risk assessment using standardized instrument OS',
    price: 50,
  },
  {
    code: '96161',
    name: 'Caregiver‑focused health risk assessment using standardized instrument OS',
    price: 50,
  },
  { code: '99483', name: 'Cognitive assessment and care plan OS', price: 350 },
  {
    code: '99495',
    name: 'TCM with moderate complexity - Contact within 2 business days- Face-to-face visit within 14 days OS',
    price: 150,
  },
  { code: '99496', name: 'TCM with high complexity OS', price: 200 },
  { code: '82947', name: 'Glucose; quantitative, blood (not fingerstick) OS', price: 200 },
  {
    code: '82962',
    name: 'Glucose, blood by glucose monitoring device(s), direct reading OS',
    price: 200,
  },
  { code: 'G0108', name: 'DSMT, individual session (per 30 minutes) OS', price: 150 },
  { code: '99458', name: 'Monitoring (for glucose, etc.) - Additional 20 min OS', price: 150 },
  { code: 'J3420', name: 'vitamin b12 OS', price: 50 },
  { code: '87426', name: 'covid test OS', price: 75 },
  { code: 'J0696', name: 'rocephin 500 mg OS', price: 100 },
  { code: '97010', name: 'application of hot or cold packs OS', price: 75 },
  { code: '97012', name: 'mechanical traction', price: 75 },
  { code: '97014', name: 'electric stimulation', price: 75 },
  { code: '97110', name: 'therapeutic exercises OS', price: 75 },
  { code: '97116', name: 'gait training OS', price: 75 },
  { code: '97124', name: 'massage', price: 100 },
  { code: '97140', name: 'manual therapy OS', price: 100 },
  { code: 'G0446', name: 'cardiovascular disease counseling', price: 150 },
  { code: 'G0105', name: 'colorectal screening and counseling', price: 75 },
  { code: 'G9501', name: 'performance of verified pain assessment', price: 50 },
  { code: 'G8731', name: 'pain assessment documented as negative', price: 50 },
  { code: 'G8730', name: 'pain assessment documented as positive' },
  { code: '90832', name: 'psychotherapy OS', price: 100 },
  { code: '20610', name: 'knee injection OS', price: 150 },
  { code: '17110', name: 'wart destruction OS', price: 150 },
  { code: '10120', name: 'incision and drainage of foreign body OS', price: 150 },
  { code: '20552', name: 'trigger point injection OS', price: 150 },
  { code: '93922', name: 'ABI OS', price: 200 },
  { code: 'G04445', name: 'std prevention counseling', price: 50 },
  { code: '96040', name: '30 minutes of genetic counseling OS', price: 150 },
  { code: 'S0265', name: 'genetic counseling non medicare OS', price: 150 },
  { code: '97530', name: 'therapeutic activities OS', price: 100 },
  { code: '96365', name: 'therapautic infusion OS', price: 250 },
  { code: 'J7040', name: 'NS 500 cc OS', price: 250 },
  { code: '87880', name: 'rapid strep test OS', price: 50 },
  { code: '87805', name: 'rapid influenza a and b OS', price: 50 },
  { code: '10060', name: 'incision and drainage OS', price: 200 },
  { code: '10061', name: 'additional abcess OS', price: 200 },
  { code: '99417', name: 'extended time', price: 100 },
  { code: '99473', name: 'self measured BP OS', price: 100 },
  { code: 'G0296', name: 'lung cancer counseling OS', price: 100 },
  { code: '99058', name: 'urgent care', price: 100 },
  { code: '99358', name: 'non face to face services', price: 100 },
  { code: '99497', name: 'advance care discussion OS', price: 175, priceMidlevel: 150 },
  {
    code: '99498',
    name: 'Advance-care planning, each additional 30 min',
    price: 150,
    priceMidlevel: 130,
  },
  { code: '94664', name: 'nebulizer use technique OS', price: 100 },
  { code: '99664', name: 'glucometer training OS', price: 100 },
  { code: '97802', name: 'nutrition counseling OS', price: 100 },
  { code: '99080', name: 'insurance paperwork', price: 100 },
  { code: 'G2212', name: 'extra work for chronic condition management os', price: 100 },
  { code: 'G2210', name: 'extended visit for high severity OS', price: 100 },
  { code: '96156', name: 'health behavior intervention os', price: 100 },
  { code: 'G2012', name: 'virtual check in os', price: 100 },
  { code: 'G2010', name: 'remote evaluation of patient recorded video OS', price: 100 },
  { code: '99491', name: 'coordination code complex os', price: 100 },
  { code: 'G0023', name: 'pin code', price: 100 },
  { code: 'G0140', name: 'pin code', price: 100 },
  { code: '99459', name: 'pap smear supplies', price: 100 },
  { code: '96125', name: 'neurobehavioral standard exam os', price: 250 },
  { code: '96136', name: 'neurocognitive exam os', price: 250 },
  { code: '96138', name: 'initial cognitive testing os', price: 250 },
  { code: '96146', name: 'automated testing OS', price: 250 },
  { code: '96132', name: 'first hour of cognitive test os', price: 250 },
  { code: '96131', name: 'first hour of testing os', price: 250 },
  { code: '99453', name: 'rpm os', price: 150 },
  { code: 'G00557', name: 'advanced primary care management', price: 150 },
  { code: 'G00558', name: 'advanced primary care management', price: 150 },
  { code: '99402', name: 'preventive care', price: 150 },
  { code: '97597', name: 'wound debridement OS', price: 200 },
  { code: '97598', name: 'wound care os', price: 200 },
  { code: 'G0109', name: 'DM counseling', price: 200 },
  { code: '98925', name: 'omt 1 OS', price: 100 },
  { code: '98926', name: 'omt 2 OS', price: 100 },
  { code: '98927', name: 'omt 3 OS', price: 100 },
  { code: '11301', name: 'shave biopsy OS', price: 200 },
  { code: '12001', name: 'laceration repair OS', price: 200 },
  { code: '17250', name: 'cauterization of bleeding OS', price: 200 },
  { code: '94640', name: 'nebulizer OS', price: 200 },
  { code: 'J7611', name: 'albuterol OS', price: 200 },
  { code: 'j7613', name: 'albuterol neb OS', price: 200 },
  { code: '97162', name: 'pt OS', price: 200 },
  { code: '97161', name: 'PT initial OS', price: 200 },
  { code: '97112', name: 'neuvascular re education OS', price: 200 },
  { code: '97535', name: 'self care home management training OS', price: 200 },
  { code: 'J1100', name: 'dexamethasone injection OS', price: 200 },
  { code: '20550', name: 'tendon sheath injection OS', price: 200 },
  { code: '11201', name: 'skin tag removal OS', price: 200 },
  { code: '98960', name: 'self management chronic condition OS', price: 200 },
  { code: '99051', name: 'weekend hours', price: 100 },
  { code: '97350', name: 'functional ADL OS', price: 150 },
  { code: '95249', name: 'cgm set up OS', price: 200 },
  { code: '95250', name: 'sensor placement and data collection OS', price: 200 },
  { code: '95251', name: 'cgm report OS', price: 200 },
  { code: '96374', name: 'iv push OS', price: 200 },
  { code: '999483', name: 'neuropsych testing OS', price: 100 },
  { code: 'G0136', name: 'medicare sdoh risk', price: 50, priceMidlevel: 45 },
  { code: '97353', name: 'functional adl OS', price: 100 },
  { code: '82044', name: 'urine microalbumin OS', price: 100 },
  { code: '82570', name: 'QW  urine creatine OS', price: 100 },
  { code: '82043', name: 'QW  urine to creatinine ration OS', price: 100 },
  { code: '95806', name: 'home sleep apnea OS', price: 300 },
  { code: '87636', name: 'covid test os', price: 100 },
  { code: '93224', name: 'holter global', price: 200 },
  { code: '93225', name: 'holter hookup', price: 100 },
  { code: '93226', name: 'scan', price: 100 },
  { code: '93227', name: 'holter interpretation', price: 100 },
  { code: 'EO720', name: '2 leads tens', price: 100 },
  { code: 'E0730', name: '4 leads tens', price: 100 },
  { code: '994467', name: 'coordination with specialist', price: 100 },
  { code: '99451', name: 'coordination written report', price: 50 },
  { code: '99484', name: 'behavioral health coordination', price: 100 },
  { code: '98975', name: 'rtm', price: 200 },
  { code: '98980', name: 'monitoring time', price: 100 },
  { code: '93241', name: 'extended patch monitors', price: 200 },
  { code: '99366', name: 'iv infusion', price: 100 },
  { code: '29540', name: 'kinesiology tape', price: 100 },
  { code: 'J1071', name: 'testosterone injection', price: 150 },
  { code: 'J1885', name: 'ketorola', price: 150 },
]
